module.exports = __webpack_public_path__ + "mcbenik.webp?791eae582d2537a6f5d0fd5a22a5bdee";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/mcbenik.webp
// module id = 290
// module chunks = 0